<template>
  <transition name="comp-basket-aside">
    <div class="comp-basket-aside" v-if="isLogin" v-onoutside="() => {showPaper = false}">
      <div class="toggle-btn flex-col-center cur-poi" @click="showPaper = !showPaper">
        <span class="text">试</span>
        <span class="text">题</span>
        <span class="text">篮</span>
        <span class="num">{{quesBasketSubjectSum}}</span>
      </div>
      <div class="toggle-btn flex-col-center cur-poi second" :class="{'disabled': quesBasketSubjectSum == 0}" style="top:420px;" @click="bindCreatePaper">
        <span class="text">生</span>
        <span class="text">成</span>
        <span class="text">试</span>
        <span class="text">卷</span>
      </div>
      <div class="my-paper" v-show="showPaper">
        <div class="top flex-between text-primary">
          <span class="f20">我的试卷</span>
          <span class="f13 cur-poi" :class="{'disabled': quesBasketSubjectSum == 0}" @click="bindClearBasket"><i class="iconfont iconshanchu"></i> 清空试卷</span>
        </div>
        <div class="paper-main p15">
          <div class="f15 mb15">已加入试题 <span class="text-color-3 f13">(共<span class="text-orange">{{quesBasketSubjectSum}}</span>题)</span></div>
          <div v-for="(item, key) in quesBasketTypeList" :key="key" class="type-item flex-between mb5">
            <div class="tit">{{item[0].typesName}}</div>
            <div class="text-color-2"><span class="text-orange">{{item | typeQuesNum}}</span> 题
              <el-tooltip effect="dark" :content="`删除${item[0].typesName}试题`" placement="top" :open-delay="150">
                <span @click="bindRemoveType(item, item[0].typesName)" class="iconfont iconshanchu ml10 text-color-3 cur-poi"></span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div><button class="btn btn-primary btn-submit" :disabled="quesBasketSubjectSum == 0" @click="bindCheckQues">查看试题</button></div>
      </div>
    </div>
  </transition>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/10
   * @project zujuanzaixian
   * @desc
   */
  import {mapGetters, mapMutations} from 'vuex'
  import {basketCreatePaperMixin} from '../../mixins/create-paper'

  export default {
    name: 'comp-basket-aside',
    mixins: [basketCreatePaperMixin],
    props: {},
    data () {
      return {
        showPaper: false
      }
    },
    computed: {
      ...mapGetters('common', ['currentSubject']),
      ...mapGetters('user', ['isLogin']),
      ...mapGetters('basket', ['quesBasket', 'quesBasketSubjectSum', 'quesBasketTypeList']),
      subjectID () {
        return this.currentSubject.id
      }
    },
    filters: {
      typeQuesNum (items) {
        let num = 0
        _.each(items, item => {
          num += item.testNum
        })
        return num
      }
    },
    methods: {
      ...mapMutations('basket', ['addTypeCompose', 'removeBasketType', 'clearQuesBasket']),
      ...mapMutations('pop', ['updateBasketQuesListPopVisible']),
      bindCheckQues () {
        let vm = this
        let quesMap = vm.quesBasket[vm.subjectID]
        _.each(quesMap, item => {
          vm.addTypeCompose(item)
        })
        this.updateBasketQuesListPopVisible(true)
      },
      bindClearBasket () {
        this.$MsgBox({
          title: '提醒',
          message: `确认要清空“<span class="text-primary">${this.currentSubject.fullname}</span>”试题篮中的试题吗？`,
          width: '450px',
          icon: 'warning',
          type: 'confirm',
          callback: (type) => {
            if (type === 'confirm') {
              this.clearQuesBasket(this.subjectID)
            }
          }
        })
      },
      bindRemoveType (items, name) {
        this.$MsgBox({
            title: '提醒',
            message: `确认要删除试题篮中的“<span class="text-primary">${name}</span>”吗？`,
            width: '450px',
            icon: 'warning',
            type: 'confirm',
            callback: (type) => {
              if (type === 'confirm') {
                // 删除试题篮中某一类型试题
                this.removeBasketType(items)
              }
            }
          })
      }
    }
  }
</script>

<style lang="less">
  @import "../../styles/_mixins-wln";
  @cubic-bezier: cubic-bezier(.55, 0, .1, 1);
  .comp-basket-aside {
    position: fixed;
    top: 0;
    right: 0;
    transform: translate3d(0, 0, calc(-100% + 30));
    transition: transform 0.35s @cubic-bezier;
    z-index: 1000;

    &-enter, &-leave-to {
      /*opacity: 0;*/
      transform: translate3d(0, 0, -100%);
    }
    .toggle-btn {
      position: absolute;
      top: 300px;
      left: -30px;
      width: 30px;
      padding: 10px;
      background: @primary;
      color: @white;
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
      &.primary {
        background: @primary;
      }
      &.second {
        background: @second;
      }

      .text {
        margin: 3px 0;
        display: block;
      }

      .num {
        margin: 3px 0;
        display: block;
        background: @orange;
        width: 20px;
        height: 16px;
        border-radius: 8px;
        text-align: center;
        font-size: 12px;
        line-height: 16px;
      }
    }

    .my-paper {
      height: 100vh;
      width: 240px;
      background: #FAFAFA;
      border-left: 3px solid @primary;

      .top {
        background: #F2F2F2;
        padding: 20px 15px;
      }

      .type-item {
        background: @white;
        padding: 14px 12px;
      }

      .btn-submit {
        margin-left: 40px;
        width: 160px;
        border-radius: 40px;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
</style>
